/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "POOL_NFT_APPROVE_CALLER_NOT_OWNER_OR_APPROVED_FOR_ALL",
        type: "error",
    },
    {
        inputs: [],
        name: "POOL_NFT_APPROVE_TO_CALLER",
        type: "error",
    },
    {
        inputs: [],
        name: "POOL_NFT_APPROVE_TO_CURRENT_OWNER",
        type: "error",
    },
    {
        inputs: [],
        name: "POOL_NFT_INVALID_TOKEN_ID",
        type: "error",
    },
    {
        inputs: [],
        name: "POOL_NFT_NOT_REGISTERED_POOL",
        type: "error",
    },
    {
        inputs: [],
        name: "POOL_NFT_ONLY_SUPER_TOKEN_FACTORY",
        type: "error",
    },
    {
        inputs: [],
        name: "POOL_NFT_TRANSFER_CALLER_NOT_OWNER_OR_APPROVED_FOR_ALL",
        type: "error",
    },
    {
        inputs: [],
        name: "POOL_NFT_TRANSFER_NOT_ALLOWED",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address",
            },
        ],
        name: "CodeUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "MetadataUpdate",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "DEFAULT_BASE_URI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "GENERAL_DISTRIBUTION_AGREEMENT_V1",
        outputs: [
            {
                internalType: "contract IGeneralDistributionAgreementV1",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "HOST",
        outputs: [
            {
                internalType: "contract ISuperfluid",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "baseURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "pool",
                type: "address",
            },
            {
                internalType: "address",
                name: "admin",
                type: "address",
            },
        ],
        name: "getTokenId",
        outputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "nftName",
                type: "string",
            },
            {
                internalType: "string",
                name: "nftSymbol",
                type: "string",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "pool",
                type: "address",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "poolAdminDataByTokenId",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "pool",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "admin",
                        type: "address",
                    },
                ],
                internalType: "struct IPoolAdminNFT.PoolAdminNFTData",
                name: "data",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "triggerMetadataUpdate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address",
            },
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x60c06040523480156200001157600080fd5b5060405162001815380380620018158339810160408190526200003491620000f4565b6001600160a01b0381166080819052604051635b69006f60e11b81527fdfd8ece9bfbcb8c5c540edb935641f63d67686490a1ab97f000288759f30a946600482015282919063b6d200de90602401602060405180830381865afa158015620000a0573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190620000c69190620000f4565b6001600160a01b031660a052506200011b9050565b6001600160a01b0381168114620000f157600080fd5b50565b6000602082840312156200010757600080fd5b81516200011481620000db565b9392505050565b60805160a0516116c66200014f600039600081816102280152610de1015260008181610309015261062301526116c66000f3fe608060405234801561001057600080fd5b506004361061018e5760003560e01c806352d1902d116100de5780639903ad3811610097578063b88d4fde11610071578063b88d4fde146103e3578063b943855e146103f6578063c87b56dd14610409578063e985e9c51461041c57600080fd5b80639903ad38146103c0578063a22cb465146103c8578063a497325b146103db57600080fd5b806352d1902d146103465780636352211e146103765780636a627842146103895780636c0360eb1461039c57806370a08231146103a457806395d89b41146103b857600080fd5b80632f3885601161014b578063469519541161012557806346951954146102f157806349f289dc146103045780634cd88b761461032b57806350d75d251461033e57600080fd5b80632f3885601461024a57806338e266661461025d57806342842e0e146102de57600080fd5b806301ffc9a71461019357806306fdde03146101bb578063081812fc146101d0578063095ea7b3146101fb57806323b872dd146102105780632925af7e14610223575b600080fd5b6101a66101a1366004611109565b61042f565b60405190151581526020015b60405180910390f35b6101c3610481565b6040516101b29190611157565b6101e36101de36600461118a565b610513565b6040516001600160a01b0390911681526020016101b2565b61020e6102093660046111b8565b61053a565b005b61020e61021e3660046111e4565b6105c6565b6101e37f000000000000000000000000000000000000000000000000000000000000000081565b61020e61025836600461118a565b6105f8565b6102b761026b36600461118a565b604080518082019091526000808252602082015250600090815260166020908152604091829020825180840190935280546001600160a01b039081168452600190910154169082015290565b6040805182516001600160a01b0390811682526020938401511692810192909252016101b2565b61020e6102ec3660046111e4565b610604565b61020e6102ff366004611225565b61061f565b6101e37f000000000000000000000000000000000000000000000000000000000000000081565b61020e6103393660046112ee565b6106db565b6101e36107c1565b7f7e88af0054b97eb67e0f614db4ab434d9acaf3d32807ccdc88da6fad8d1fce335b6040519081526020016101b2565b6101e361038436600461118a565b6107f0565b61020e610397366004611225565b610829565b6101c3610832565b6103686103b2366004611225565b50600190565b6101c3610852565b61020e610861565b61020e6103d6366004611360565b610923565b6101c361092e565b61020e6103f1366004611399565b61094a565b610368610404366004611419565b610983565b6101c361041736600461118a565b610996565b6101a661042a366004611419565b6109a1565b60006301ffc9a760e01b6001600160e01b03198316148061046057506380ac58cd60e01b6001600160e01b03198316145b8061047b5750635b5e139f60e01b6001600160e01b03198316145b92915050565b60606001805461049090611447565b80601f01602080910402602001604051908101604052809291908181526020018280546104bc90611447565b80156105095780601f106104de57610100808354040283529160200191610509565b820191906000526020600020905b8154815290600101906020018083116104ec57829003601f168201915b5050505050905090565b600061051e826109cf565b506000908152600360205260409020546001600160a01b031690565b6000610545826107f0565b9050806001600160a01b0316836001600160a01b0316036105795760405163020226d360e01b815260040160405180910390fd5b336001600160a01b03821614801590610599575061059781336109a1565b155b156105b757604051631e82f25560e01b815260040160405180910390fd5b6105c18383610a07565b505050565b6105d03382610a71565b6105ed57604051632014770760e11b815260040160405180910390fd5b6105c1838383610ad0565b61060181610ae9565b50565b6105c18383836040518060200160405280600081525061094a565b60007f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031663731aed6e6040518163ffffffff1660e01b8152600401602060405180830381865afa15801561067f573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906106a39190611481565b9050336001600160a01b038216146106ce576040516303fafc7b60e31b815260040160405180910390fd5b6106d782610b19565b5050565b600054610100900460ff16158080156106fb5750600054600160ff909116105b806107155750303b158015610715575060005460ff166001145b61073a5760405162461bcd60e51b81526004016107319061149e565b60405180910390fd5b6000805460ff19166001179055801561075d576000805461ff0019166101001790555b6001610769848261153a565b506002610776838261153a565b5080156105c1576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a1505050565b60006107eb7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc5490565b905090565b6000818152601660205260408120600101546001600160a01b03168061047b57604051630249d66560e21b815260040160405180910390fd5b61060181610d53565b60606040518060600160405280602e8152602001611663602e9139905090565b60606002805461049090611447565b600054610100900460ff16158080156108815750600054600160ff909116105b8061089b5750303b15801561089b575060005460ff166001145b6108b75760405162461bcd60e51b81526004016107319061149e565b6000805460ff1916600117905580156108da576000805461ff0019166101001790555b8015610601576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb3847402498906020015b60405180910390a150565b6106d7338383610fba565b6040518060600160405280602e8152602001611663602e913981565b6109543383610a71565b61097157604051632014770760e11b815260040160405180910390fd5b61097d84848484611059565b50505050565b600061098f8383611064565b9392505050565b606061047b826110d9565b6001600160a01b03918216600090815260046020908152604080832093909416825291909152205460ff1690565b6000818152601660205260409020600101546001600160a01b031661060157604051630249d66560e21b815260040160405180910390fd5b600081815260036020908152604080832080546001600160a01b0319166001600160a01b038781169182179092556016909352818420600101549151859492909116917f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b92591a45050565b600080610a7d836107f0565b9050806001600160a01b0316846001600160a01b03161480610aa45750610aa481856109a1565b80610ac85750836001600160a01b0316610abd84610513565b6001600160a01b0316145b949350505050565b6040516302197d8b60e51b815260040160405180910390fd5b6040518181527ff8e1a15aba9398e019f0b49df1a4fde98ee17ae345cb5f6b5e2c27f5033e8ce790602001610918565b6000610b437f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc5490565b6001600160a01b031603610b995760405162461bcd60e51b815260206004820152601d60248201527f5555505350726f786961626c653a206e6f742075706772616461626c650000006044820152606401610731565b806001600160a01b03166352d1902d6040518163ffffffff1660e01b8152600401602060405180830381865afa158015610bd7573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610bfb91906115fa565b7f7e88af0054b97eb67e0f614db4ab434d9acaf3d32807ccdc88da6fad8d1fce3314610c755760405162461bcd60e51b815260206004820152602360248201527f5555505350726f786961626c653a206e6f7420636f6d70617469626c65206c6f60448201526267696360e81b6064820152608401610731565b6001600160a01b0381163003610ccd5760405162461bcd60e51b815260206004820152601960248201527f5555505350726f786961626c653a2070726f7879206c6f6f70000000000000006044820152606401610731565b610cf5817f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc55565b7fe011bc04c286c344a8fcbb8de77f953da762c3e25d8cdea984147fc4168a5dcc7f7e88af0054b97eb67e0f614db4ab434d9acaf3d32807ccdc88da6fad8d1fce33604080519182526001600160a01b038416602083015201610918565b6000816001600160a01b0316632b4116f76040518163ffffffff1660e01b8152600401602060405180830381865afa158015610d93573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610db79190611481565b604051633d96606d60e11b81526001600160a01b03808316600483015284811660248301529192507f000000000000000000000000000000000000000000000000000000000000000090911690637b2cc0da90604401602060405180830381865afa158015610e2a573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610e4e9190611613565b610e6b57604051633210c89760e11b815260040160405180910390fd5b60008290506000816001600160a01b031663f851a4406040518163ffffffff1660e01b8152600401602060405180830381865afa158015610eb0573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610ed49190611481565b9050806001600160a01b0316846001600160a01b031603610ef757610ef7611630565b6000610f038583611064565b6000818152601660205260409020600101549091506001600160a01b031615610f2e57610f2e611630565b6040805180820182526001600160a01b038088168252848116602080840182815260008781526016909252858220945185549085166001600160a01b0319918216178655905160019095018054959094169416939093179091559151839291907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef908290a45050505050565b816001600160a01b0316836001600160a01b031603610fec57604051639212b33360e01b815260040160405180910390fd5b6001600160a01b03838116600081815260046020908152604080832094871680845294825291829020805460ff191686151590811790915591519182527f17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c31910160405180910390a3505050565b61097d848484610ad0565b60004683836040516020016110ba939291906080808252600c908201526b141bdbdb10591b5a5b93919560a21b60a082015260208101939093526001600160a01b03918216604084015216606082015260c00190565b60408051601f1981840301815291905280516020909101209392505050565b60606110e3610832565b6040516020016110f39190611646565b6040516020818303038152906040529050919050565b60006020828403121561111b57600080fd5b81356001600160e01b03198116811461098f57600080fd5b60005b8381101561114e578181015183820152602001611136565b50506000910152565b6020815260008251806020840152611176816040850160208701611133565b601f01601f19169190910160400192915050565b60006020828403121561119c57600080fd5b5035919050565b6001600160a01b038116811461060157600080fd5b600080604083850312156111cb57600080fd5b82356111d6816111a3565b946020939093013593505050565b6000806000606084860312156111f957600080fd5b8335611204816111a3565b92506020840135611214816111a3565b929592945050506040919091013590565b60006020828403121561123757600080fd5b813561098f816111a3565b634e487b7160e01b600052604160045260246000fd5b600067ffffffffffffffff8084111561127357611273611242565b604051601f8501601f19908116603f0116810190828211818310171561129b5761129b611242565b816040528093508581528686860111156112b457600080fd5b858560208301376000602087830101525050509392505050565b600082601f8301126112df57600080fd5b61098f83833560208501611258565b6000806040838503121561130157600080fd5b823567ffffffffffffffff8082111561131957600080fd5b611325868387016112ce565b9350602085013591508082111561133b57600080fd5b50611348858286016112ce565b9150509250929050565b801515811461060157600080fd5b6000806040838503121561137357600080fd5b823561137e816111a3565b9150602083013561138e81611352565b809150509250929050565b600080600080608085870312156113af57600080fd5b84356113ba816111a3565b935060208501356113ca816111a3565b925060408501359150606085013567ffffffffffffffff8111156113ed57600080fd5b8501601f810187136113fe57600080fd5b61140d87823560208401611258565b91505092959194509250565b6000806040838503121561142c57600080fd5b8235611437816111a3565b9150602083013561138e816111a3565b600181811c9082168061145b57607f821691505b60208210810361147b57634e487b7160e01b600052602260045260246000fd5b50919050565b60006020828403121561149357600080fd5b815161098f816111a3565b6020808252602e908201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160408201526d191e481a5b9a5d1a585b1a5e995960921b606082015260800190565b601f8211156105c157600081815260208120601f850160051c810160208610156115135750805b601f850160051c820191505b818110156115325782815560010161151f565b505050505050565b815167ffffffffffffffff81111561155457611554611242565b611568816115628454611447565b846114ec565b602080601f83116001811461159d57600084156115855750858301515b600019600386901b1c1916600185901b178555611532565b600085815260208120601f198616915b828110156115cc578886015182559484019460019091019084016115ad565b50858210156115ea5787850151600019600388901b60f8161c191681555b5050505050600190811b01905550565b60006020828403121561160c57600080fd5b5051919050565b60006020828403121561162557600080fd5b815161098f81611352565b634e487b7160e01b600052600160045260246000fd5b60008251611658818460208701611133565b919091019291505056fe68747470733a2f2f6e66742e7375706572666c7569642e66696e616e63652f706f6f6c2f76322f6765746d657461a2646970667358221220aed7ae1f7d2a226c9871cf47c35966f49a4849b35cfc17e0ceca775db822f6be64736f6c63430008130033";
const isSuperArgs = (xs) => xs.length > 1;
export class PoolAdminNFT__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(host, overrides) {
        return super.deploy(host, overrides || {});
    }
    getDeployTransaction(host, overrides) {
        return super.getDeployTransaction(host, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
PoolAdminNFT__factory.bytecode = _bytecode;
PoolAdminNFT__factory.abi = _abi;
//# sourceMappingURL=PoolAdminNFT__factory.js.map